import React, { useEffect, useRef } from 'react';

export default props => {
    const datepicker = useRef(null);

    useEffect(() => {
        $(datepicker.current).taghvim({
            type: (props.isPersian || true) ? 'persian' : 'gregorian',
            minDate: props.minDate || null,
            timepicker: props.timepicker || false,
            maxDate: props.maxDate || null,
            dir: (props.isPersian || true) ? 'rtl' : 'ltr',
            onSelect: (selectedDate) => props.onChange(selectedDate.formattedDate, props.name)
        });
    }, []);

    return (
        <div className='datepicker float-label'>
            <label className={`float-label__label${props.value !== '' ? ' float-label__label-out' : ''}`} htmlFor={`txt${props.name}`}>{props.label}</label>
            <input type='text'
                {...props.inputAttr}
                id={`txt${props.name}`}
                ref={datepicker}
                name={props.name}
                className='form-control'
                value={props.value}
                readOnly='readonly' />
            <i className={`icon-close ${props.value.length > 0 ? '' : 'hidden'}`} onClick={() => props.onClear(props.name)} />
        </div>
    );
}